(function () {
  'use strict';

  var config = window.__cdConfig || { shippingProtectionVariantId: 47717175427250 , discountUnlockQuantity: 2 };
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var overlay = drawer.querySelector('[data-cart-drawer-overlay]');
  var closeBtn = drawer.querySelector('[data-cart-drawer-close]');
  var itemsEl = drawer.querySelector('[data-cd-items]');
  var progressLabel = drawer.querySelector('[data-cd-progress-label]');
  var progressFill = drawer.querySelector('[data-cd-progress-fill]');
  var plane = drawer.querySelector('[data-cd-plane]');
  var protectionCheckbox = drawer.querySelector('[data-cd-protection-checkbox]');
  var protectionBlock = drawer.querySelector('[data-cd-protection]');
  var subtotalEl = drawer.querySelector('[data-cd-subtotal]');

  var lastUnlocked = false;


  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('cart-drawer:open', function () {
    fetchCart().then(openDrawer);
  });

  document.addEventListener('cart:refresh', function () {
    fetchCart();
  });

  document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart().then(openDrawer);
    });
  });

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function () {});
  }
function renderCart(cart) {
    renderItems(cart);
    renderProgress(cart);
    renderProtectionState(cart);
   renderSubtotal(cart);
  }

  function renderTimer_UNUSED(cart) {
    if (!timerEl || !timerValueEl) return;

    var productQty = cart.items.reduce(function (sum, item) {
      return isProtectionLine(item) ? sum : sum + item.quantity;
    }, 0);
    var target = config.discountUnlockQuantity || 2;
    var unlocked = productQty >= target;

    if (!unlocked) {
      timerEl.style.display = 'none';
      if (timerInterval) {
        clearInterval(timerInterval);
        timerInterval = null;
      }
      sessionStorage.removeItem(TIMER_STORAGE_KEY);
      return;
    }

    var startedAt = sessionStorage.getItem(TIMER_STORAGE_KEY);
    if (!startedAt) {
      startedAt = Date.now().toString();
      sessionStorage.setItem(TIMER_STORAGE_KEY, startedAt);
    }

    timerEl.style.display = 'flex';

    if (timerInterval) clearInterval(timerInterval);

    function tick() {
      var elapsed = Date.now() - parseInt(startedAt, 10);
      var remaining = TIMER_DURATION_MS - elapsed;

      if (remaining <= 0) {
        sessionStorage.removeItem(TIMER_STORAGE_KEY);
        startedAt = Date.now().toString();
        sessionStorage.setItem(TIMER_STORAGE_KEY, startedAt);
        remaining = TIMER_DURATION_MS;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      timerValueEl.textContent = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

      timerEl.setAttribute('data-cd-timer-urgent', totalSeconds <= 120 ? 'true' : 'false');
    }

    tick();
    timerInterval = setInterval(tick, 1000);
  }

  function renderItems(cart) {
    if (!itemsEl) return;

    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cd__empty">Your bag is empty</p>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      if (isProtectionLine(item)) return;

      var imageSrc = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_200x$1$2') : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

      html += ''
        + '<div class="cd__item" data-cd-line-key="' + item.key + '">'
        + '  <div class="cd__item-image">' + (imageSrc ? '<img src="' + imageSrc + '" alt="' + escapeHtml(item.product_title) + '">' : '') + '</div>'
        + '  <div class="cd__item-body">'
        + '    <p class="cd__item-title">' + escapeHtml(item.product_title) + '</p>'
        + (variantTitle ? '    <p class="cd__item-variant">' + escapeHtml(variantTitle) + '</p>' : '')
        + '    <div class="cd__item-qty-row">'
        + '      <div class="cd__item-qty">'
        + '        <button type="button" data-cd-qty-decrease>−</button>'
        + '        <span>' + item.quantity + '</span>'
        + '        <button type="button" data-cd-qty-increase>+</button>'
        + '      </div>'
        + '      <span class="cd__item-price">' + formatMoney(item.final_line_price) + '</span>'
        + '    </div>'
        + '    <button type="button" class="cd__item-remove" data-cd-remove>Remove</button>'
        + '  </div>'
        + '</div>';
    });

    itemsEl.innerHTML = html || '<p class="cd__empty">Your bag is empty</p>';

    itemsEl.querySelectorAll('[data-cd-line-key]').forEach(function (row) {
      var key = row.getAttribute('data-cd-line-key');
      var decreaseBtn = row.querySelector('[data-cd-qty-decrease]');
      var increaseBtn = row.querySelector('[data-cd-qty-increase]');
      var removeBtn = row.querySelector('[data-cd-remove]');
      var qtySpan = row.querySelector('.cd__item-qty span');

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          var newQty = Math.max(0, parseInt(qtySpan.textContent, 10) - 1);
          updateLine(key, newQty);
        });
      }
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          var newQty = parseInt(qtySpan.textContent, 10) + 1;
          updateLine(key, newQty);
        });
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          updateLine(key, 0);
        });
      }
    });
  }

  function isProtectionLine(item) {
    return config.shippingProtectionVariantId && item.variant_id === config.shippingProtectionVariantId;
  }

  function updateLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderProgress(cart) {
    if (!progressLabel || !progressFill || !plane) return;

    var productQty = cart.items.reduce(function (sum, item) {
      return isProtectionLine(item) ? sum : sum + item.quantity;
    }, 0);

    var target = config.discountUnlockQuantity || 2;
    var pct = Math.min(100, (productQty / target) * 100);
    var unlocked = productQty >= target;

    progressFill.style.width = pct + '%';
    plane.style.left = pct + '%';

    if (unlocked) {
      progressLabel.textContent = 'Discount unlocked! Enjoy your savings.';
      plane.classList.remove('is-flying');
      if (!lastUnlocked) {
        plane.classList.add('is-unlocked');
        setTimeout(function () { plane.classList.remove('is-unlocked'); }, 650);
      }
    } else {
      var remaining = target - productQty;
      progressLabel.textContent = remaining === 1
        ? 'Add 1 more item to unlock your discount!'
        : 'Add ' + remaining + ' more items to unlock your discount!';
      plane.classList.add('is-flying');
    }

    lastUnlocked = unlocked;
  }

  function renderProtectionState(cart) {
    if (!protectionCheckbox) return;

    var hasProtection = cart.items.some(isProtectionLine);
    protectionCheckbox.checked = hasProtection;
  }

  function renderSubtotal(cart) {
    if (!subtotalEl) return;
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  if (protectionCheckbox) {
    protectionCheckbox.addEventListener('change', function () {
      if (!config.shippingProtectionVariantId) {
        protectionCheckbox.checked = false;
        return;
      }

      if (protectionCheckbox.checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: config.shippingProtectionVariantId, quantity: 1 }),
        })
          .then(function () { return fetchCart(); })
          .catch(function () {});
      } else {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var line = cart.items.find(isProtectionLine);
            if (line) return updateLine(line.key, 0);
          })
          .catch(function () {});
      }
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart();
  });

  if (document.readyState !== 'loading') {
    fetchCart();
  }
})();